import { Phone, Home, Info } from "lucide-react";
import { useSitePhone } from "@/hooks/useSitePhone";
const tronLogo = { url: "/logos/tron-gold-logo.webp" };

/**
 * Minimal header for paid-traffic landing pages.
 * Logo + tracked Call Now only — no service navigation, no escape links.
 * Click tracking is handled globally by ConversionTracking (tel: delegation).
 */
const LandingHeader = () => {
  const { phone, phoneLink } = useSitePhone();

  return (
    <header
      className="relative z-50 border-b border-accent/30"
      style={{ backgroundColor: "#1A1A1A", color: "#F5E6C4" }}
    >
      <div className="container mx-auto px-4 h-14 md:h-[68px] flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 md:gap-4 min-w-0">
          <span className="flex items-center gap-2 min-w-0" aria-label="Tron Electrical">
            <img
              src={tronLogo.url}
              alt="Tron Electrical"
              width={56}
              height={56}
              className="h-9 md:h-12 w-auto object-contain shrink-0"
              loading="eager"
              decoding="async"
            />
            <span
              className="hidden sm:inline font-bold tracking-wide truncate text-[15px] md:text-2xl"
              style={{ color: "#F5E6C4" }}
            >
              TRON Electrical
            </span>
          </span>

          <a
            href="/"
            aria-label="Go to Tron Electrical homepage"
            className="inline-flex items-center gap-1.5 rounded-lg border px-2.5 md:px-3.5 text-[12px] md:text-sm font-semibold whitespace-nowrap transition-colors hover:bg-white/10"
            style={{ minHeight: "36px", borderColor: "rgba(212,175,55,0.5)", color: "#F5E6C4" }}
          >
            <Home className="w-4 h-4 shrink-0" aria-hidden="true" />
            Home
          </a>

          <a
            href="/about"
            aria-label="Learn about Tron Electrical"
            className="inline-flex items-center gap-1.5 rounded-lg border px-2.5 md:px-3.5 text-[12px] md:text-sm font-semibold whitespace-nowrap transition-colors hover:bg-white/10"
            style={{ minHeight: "36px", borderColor: "rgba(212,175,55,0.5)", color: "#F5E6C4" }}
          >
            <Info className="w-4 h-4 shrink-0" aria-hidden="true" />
            About
          </a>

        </div>


        <a
          href={phoneLink}
          aria-label={`Call Tron Electrical at ${phone}`}
          className="inline-flex items-center justify-center gap-2 rounded-xl px-3.5 md:px-5 font-bold text-[13px] md:text-[15px] whitespace-nowrap"
          style={{
            minHeight: "44px",
            background: "linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)",
            color: "#0B0B0C",
          }}
        >
          <Phone className="w-4 h-4 shrink-0" aria-hidden="true" />
          <span className="hidden sm:inline">{phone} </span>Call Now
        </a>
      </div>
    </header>
  );
};

export default LandingHeader;
